import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTooltip } from 'src/components/CustomTooltip';
import { useIsTranslated } from 'src/lib/hooks';

import { AddInfoButton } from '../AddInfoButton';

import { useStyles } from './useStyles';

export const ContinueRowFloatingPanel = ({ className, onAddClick, disabled, isPromptField }) => {
  const styles = useStyles();

  const isTranslated = useIsTranslated();

  const title = isPromptField
    ? 'Add context to this prompt:\nFile, Web page, Image...'
    : 'Add context to your answer:\nFile, Web page, Image...';

  return (
    <span
      className={cx(styles.root, className)}
      data-testid="continueRowFloatingPanel"
    >
      <CustomTooltip
        title={title}
        placement="bottom"
      >
        <AddInfoButton
          className={styles.button}
          onClick={onAddClick}
          disabled={disabled || isTranslated}
          data-testid="promptInstructionsAddInfoButton"
        />
      </CustomTooltip>
    </span>
  );
};
ContinueRowFloatingPanel.propTypes = {
  className: PropTypes.string,
  onAddClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isPromptField: PropTypes.bool,
};
ContinueRowFloatingPanel.defaultProps = {
  className: null,
  disabled: false,
  isPromptField: false,
};
